<template>
    <v-container>
        <v-row>
        <v-col>
            <v-btn-toggle
            v-if="this.hasStarOrder"
            v-model="order_bar"
            @change="changed"
            shaped
            mandatory
            background-color="#e6ecff"
          >
            <v-icon size="30">mdi-sort</v-icon>
            <v-btn>
              <v-icon>mdi-star-outline</v-icon>
            </v-btn>
            <v-btn>
              <v-icon>mdi-message-text-clock-outline</v-icon>
            </v-btn>
          </v-btn-toggle>
          </v-col>
          <v-col class="text-right">
              <v-btn-toggle
            v-model="filter_bar"
            @change="changed"
            shaped
            multiple
            background-color="#e6ecff"
          >
            <v-btn>
              <v-icon>mdi-television-classic</v-icon>
            </v-btn>
            <v-btn>
              <v-icon>mdi-movie-outline</v-icon>
            </v-btn>
            <v-btn v-if="hasStar">
              <v-icon>mdi-star-off</v-icon>
            </v-btn>
            <v-icon size="30">mdi-filter-minus-outline</v-icon>
          </v-btn-toggle>
          </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
  name: 'FilterAndOrder',
  props: ['hasStar', 'hasStarOrder'],
  data() {
    return {
      filter_bar: [0, 1, 2],
      order_bar: [],
      lastfilter: null,
    };
  },
  computed: {
    starFilter() {
      return (this.filter_bar.indexOf(2) !== -1 || !this.hasStar);
    },
    seriesFilter() {
      return this.filter_bar.indexOf(0) !== -1;
    },
    moviesFilter() {
      return this.filter_bar.indexOf(1) !== -1;
    },
    definedOrder() {
      if (this.order_bar === 0) {
        return 'rate';
      }
      return 'date';
    },
  },
  methods: {
    changed() {
      const resp = {
        rated: this.starFilter,
        series: this.seriesFilter,
        movies: this.moviesFilter,
        order: this.definedOrder,
      };
      if (JSON.stringify(this.lastfilter) !== JSON.stringify(resp)) {
        this.lastfilter = resp;
        this.$emit('change', resp);
      }
    },
  },
};
</script>
